import React, {useState} from 'react';
import axios from "axios";
import Loading from "../animations/Loading";
import { useAlert } from "../context/AlertContext";

const ErrorPage = ({ setIsLoggedIn }) => {
    const URL_API = process.env.REACT_APP_URL_API || 'http://localhost:5000';
    const { showAlert } = useAlert();
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#00bf63',
            color: 'white',
            textAlign: 'center',
            padding: '20px',
            boxSizing: 'border-box',
        },
        title: {
            fontSize: '36px',
        },
        message: {
            fontSize: '20px',
            margin: '20px 0',
        },
        logoutButton: {
            padding: '10px 20px',
            fontSize: '18px',
            backgroundColor: 'white',
            color: '#00bf63',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
        },
    };

    const [loading, setLoading] = useState(false);

    if (loading) {
        return <Loading />;
    }

    const handleLogout = async () => {
        try {
            const userSession = localStorage.getItem("userSession");
            
            if(userSession){
                const response = await axios.post(URL_API+"auth/logout", {
                    correo: localStorage.getItem("userSession")
                });

                if(response.data.success){
                    localStorage.removeItem("userSession");
                    localStorage.removeItem("tipoSession");
                    localStorage.removeItem("tokenSession");

                    setLoading(true);
                    setTimeout(() => {
                        setIsLoggedIn(false);
                        showAlert(response.data.message, "success");
                    }, 1000);
                } else{
                    showAlert(response.data.message, "error");
                }
            }
        } catch (error) {
            showAlert("Error al conectar con el servidor", "error");
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>
                Lo sentimos, no cuentas con los permisos para acceder al sitio.
            </h1>
            <p style={styles.message}>
                Si crees que se trata de un error, contáctate con un administrador.
            </p>
            <button 
                onClick={handleLogout}
                style={styles.logoutButton}
            >
                Cerrar Sesión
            </button>
        </div>
    );
};

export default ErrorPage;